import type { MenuItemProps } from './MenuItem'
import MenuItem from './MenuItem'

export type { MenuItemProps }
export default MenuItem
